import { Outlet } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  return <Outlet />;
}
